'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.renderAfter = renderAfter;
exports.renderAfterInitialData = renderAfterInitialData;
exports.renderAfterDoneLoading = renderAfterDoneLoading;

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _amsLoaderUtils = require('@artsman/ams-loader-utils');

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Return true if the props is not undefined
 */
function isNotUndefined(propValue) {
  return propValue !== undefined;
}

/*
 * Higher Order Component (HOC) That waits for certain props to be "loaded" before displaying.
 */
function renderAfter(waitProps) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef,
      _options$isLoadedCb = options.isLoadedCb,
      isLoadedCb = _options$isLoadedCb === undefined ? isNotUndefined : _options$isLoadedCb,
      _options$SpinnerCompo = options.SpinnerComponent,
      SpinnerComponent = _options$SpinnerCompo === undefined ? function () {
    return _react2.default.createElement(
      'div',
      null,
      'Loading...'
    );
  } : _options$SpinnerCompo,
      _options$EmptyCompone = options.EmptyComponent,
      EmptyComponent = _options$EmptyCompone === undefined ? function () {
    return _react2.default.createElement('div', null);
  } : _options$EmptyCompone,
      _options$emptyTimeout = options.emptyTimeout,
      emptyTimeout = _options$emptyTimeout === undefined ? 1000 : _options$emptyTimeout,
      _options$methodName = options.methodName,
      methodName = _options$methodName === undefined ? 'renderAfter' : _options$methodName,
      _options$getDisplayNa = options.getDisplayName,
      getDisplayName = _options$getDisplayNa === undefined ? function (name) {
    return 'RenderAfter(' + name + ')';
  } : _options$getDisplayNa;

  // CONVENIENCE: turn a single string into a list.

  if (waitProps !== undefined && (typeof waitProps === 'string' || waitProps instanceof String)) {
    waitProps = [waitProps];
  }

  return function _renderAfter(WrappedComponent) {

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var RenderAfter = function (_Component) {
      _inherits(RenderAfter, _Component);

      function RenderAfter(props, context) {
        _classCallCheck(this, RenderAfter);

        var _this = _possibleConstructorReturn(this, (RenderAfter.__proto__ || Object.getPrototypeOf(RenderAfter)).call(this, props, context));

        _this.emptyTimeout = undefined;
        _this.state = {
          showEmpty: emptyTimeout !== 0,
          showLoading: _this.checkShowLoading(props)
        };
        return _this;
      }

      _createClass(RenderAfter, [{
        key: 'checkShowLoading',
        value: function checkShowLoading(props) {
          // Check props to see if all of them are in the loaded state (short-circuit fail otherwise)
          var result = void 0;
          var showLoading = false;
          waitProps.some(function (propName) {
            result = isLoadedCb(props[propName]);
            if (result === false) {
              showLoading = true;
              return true;
            }
            return false;
          });
          return showLoading;
        }
      }, {
        key: 'setEmptyTimeout',
        value: function setEmptyTimeout() {
          var _this2 = this;

          this.emptyTimeout = setTimeout(function () {
            return _this2.setState({ showEmpty: false });
          }, emptyTimeout);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          // Check the loading status to see if the empty timer needs to be reset because the props have transitioned
          // from a loaded state back to a non-loaded state without remounting.
          var showLoading = this.checkShowLoading(nextProps);
          if (emptyTimeout !== 0 && !this.state.showLoading && showLoading) {
            this.setState({ showEmpty: true, showLoading: showLoading });
            this.setEmptyTimeout();
          } else {
            this.setState({ showLoading: showLoading });
          }
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.setEmptyTimeout();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.emptyTimeout !== undefined) {
            clearTimeout(this.emptyTimeout);
            this.emptyTimeout = undefined;
          }
        }
      }, {
        key: 'setWrappedInstance',
        value: function setWrappedInstance(ref) {
          this.wrappedInstance = ref;
        }
      }, {
        key: 'getWrappedInstance',
        value: function getWrappedInstance() {
          (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));

          return this.wrappedInstance;
        }
      }, {
        key: 'render',
        value: function render() {
          if (this.state.showLoading) {
            if (this.state.showEmpty) {
              // Still within the empty timeout threshold.  Display what counts as empty.
              return (0, _react.createElement)(EmptyComponent, this.props);
            } else {
              // Out of the empty timeout, display the loading component
              return (0, _react.createElement)(SpinnerComponent, this.props);
            }
          } else {
            if (withRef) {
              return (0, _react.createElement)(WrappedComponent, _extends({}, this.props, { ref: this.setWrappedInstance }));
            } else {
              return (0, _react.createElement)(WrappedComponent, this.props);
            }
          }
        }
      }]);

      return RenderAfter;
    }(_react.Component);

    RenderAfter.displayName = displayName;
    RenderAfter.WrappedComponent = WrappedComponent;

    return (0, _hoistNonReactStatics2.default)(RenderAfter, WrappedComponent);
  };
}

/*
 * If there is a `hasInitialData` attribute on the given property then this loaded callback will return false
 * if the base property is not defined or if hasInitialData is false.
 */
function hasInitialData(propValue) {
  if (propValue === undefined) {
    return false;
  } else if (propValue.hasInitialData === false) {
    return false;
  }
  return true;
}

/*
 * If there is a `loading` attribute on the given property then this loaded callback will return false
 * if the base property is not defined or if loading is true.
 */
function doneLoading(propValue) {
  if (propValue === undefined) {
    return false;
  } else if (propValue.hasInitialData === false && propValue.loadingError === null) {
    return false;
  }
  return true;
}

/*
 * CONVENIENCE: Curry an initial data Higher Order Component that uses the 'hasInitialData' callback as the default.
 */
function renderAfterInitialData(waitProps) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = _extends({
    isLoadedCb: hasInitialData,
    methodName: 'renderAfterInitialData',
    getDisplayName: function getDisplayName(name) {
      return 'RenderAfterInitialData(' + name + ')';
    }
  }, options);
  return renderAfter(waitProps, options);
}

/*
 * CONVENIENCE: Curry an initial data Higher Order Component that uses the 'doneLoading' callback as the default.
 */
function renderAfterDoneLoading(waitProps) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = _extends({
    isLoadedCb: doneLoading,
    methodName: 'renderAfterDoneLoading',
    getDisplayName: function getDisplayName(name) {
      return 'RenderAfterDoneLoading(' + name + ')';
    }
  }, options);
  return renderAfter(waitProps, options);
}